import { css } from 'styled-components';
import theme from '../theme/theme';

const getTransition = (transtitionType = theme.transition.base) => (
	css`
      transition: ${transtitionType};
    `
);

export default getTransition;